import { render, staticRenderFns } from "./resturantChart.vue?vue&type=template&id=1be69c5c"
import script from "./resturantChart.vue?vue&type=script&lang=js"
export * from "./resturantChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports